module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic06.2f7b951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic06.png
// module id = 506
// module chunks = 1